/* tslint:disable:max-line-length */
import { colors } from '@mm/utils';
import classNames from 'classnames';
import React from 'react';
import { IconTypeProps } from '../types';

export const QuestionCircleIcon = ({
  className,
  style: styleFromProps,
  color,
  onClick,
  size,
}: IconTypeProps) => {
  const fill = color || colors.palePurple;
  const style = {
    ...styleFromProps,
    ...(size ? { width: size, height: size } : {}),
  };
  return (
    <svg
      className={classNames(className)}
      onClick={onClick}
      style={style}
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9 11.9531C8.45634 11.9531 8.01562 12.3938 8.01562 12.9375C8.01562 13.4812 8.45634 13.9219 9 13.9219C9.54366 13.9219 9.98438 13.4812 9.98438 12.9375C9.98438 12.3938 9.54366 11.9531 9 11.9531ZM9.26965 11.1094H8.70715C8.47417 11.1094 8.28527 10.9205 8.28527 10.6875V10.6741C8.28527 8.20111 11.0078 8.4375 11.0078 6.89804C11.0078 6.19436 10.3834 5.48438 8.9884 5.48438C7.9638 5.48438 7.43221 5.8236 6.90676 6.49308C6.76937 6.66816 6.51814 6.70384 6.33554 6.57661L5.8738 6.25493C5.67605 6.11715 5.63263 5.84111 5.78081 5.65105C6.52704 4.69385 7.41241 4.07812 8.9884 4.07812C10.8278 4.07812 12.414 5.12406 12.414 6.89804C12.414 9.26807 9.69152 9.14273 9.69152 10.6741V10.6875C9.69152 10.9205 9.50263 11.1094 9.26965 11.1094ZM9 1.40625C13.1703 1.40625 16.5938 4.78389 16.5938 9C16.5938 13.1938 13.1973 16.5938 9 16.5938C4.80783 16.5938 1.40625 13.199 1.40625 9C1.40625 4.80927 4.80241 1.40625 9 1.40625ZM9 0.28125C4.18511 0.28125 0.28125 4.18651 0.28125 9C0.28125 13.8163 4.18511 17.7188 9 17.7188C13.8149 17.7188 17.7188 13.8163 17.7188 9C17.7188 4.18651 13.8149 0.28125 9 0.28125Z"
        fill={fill}
      />
    </svg>
  );
};
